<template>
    <div>
        <div class="text-slate-700 text-base font-bold">Method</div>
        <div class="text-sm leading-tight mb-4 text-slate-500">
            The method of HTTP request.
        </div>

        <div class="grid sm:grid-cols-4 gap-2">
            <vx-box v-for="httpMethod in availableHttpMethods()"
                tabindex="0"
                @click.prevent="change(httpMethod.method)"
                @keydown.space.prevent="change(httpMethod.method)"
                @keydown.enter.prevent="change(httpMethod.method)"
                :aria-selected="props.active"
                :key="httpMethod.method"
                class="flex items-center p-4 gap-2 border-0"
                :class="{
                    'cursor-pointer bg-slate-100! shadow-none hover:bg-white!': props.modelValue !== httpMethod.method,
                }"
                >
                <vx-radio :modelValue="props.modelValue === httpMethod.method">
                </vx-radio>
                <vx-badge class="grow justify-center" size="lg" :color="httpMethod.color">
                    {{ httpMethod.method }}
                </vx-badge>
            </vx-box>
        </div>
    </div>
</template>

<script setup>
import { VxBox, VxRadio, VxBadge } from '@voxie/frontend-components';
import { availableHttpMethods } from '../apiDestinationHelper';

const props = defineProps({
    modelValue: {
        type: String,
        required: true,
    },
    error: {
        type: String,
        default: undefined,
    },
});

const emit = defineEmits(['update:modelValue']);

const change = (method) => emit('update:modelValue', method)
</script>
